import apiClient from './client';

export async function getProfile() {
  const res = await apiClient.get('/api/v1/profile');
  return res.data;
}

export async function createProfile(data) {
  const res = await apiClient.post('/api/v1/profile', data);
  return res.data;
}

export async function updateProfile(data) {
  const res = await apiClient.put('/api/v1/profile', data);
  return res.data;
}

export async function deleteProfile() {
  return apiClient.delete('/api/v1/profile');
}

export async function getTaxRates() {
  const res = await apiClient.get('/api/v1/profile/tax-rates');
  return res.data;
}

export async function updateTaxRates(data) {
  const res = await apiClient.put('/api/v1/profile/tax-rates', data);
  return res.data;
}

export async function getNotifications() {
  const res = await apiClient.get('/api/v1/profile/notifications');
  return res.data;
}

export async function updateNotifications(data) {
  const res = await apiClient.put('/api/v1/profile/notifications', data);
  return res.data;
}